import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fileUrl } from "../lib/api";

export default function PhotoCard({ photo, className = "", index = 0, natural = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 4) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      <Link
        to={`/photo/${photo.id}`}
        data-testid={`photo-card-${photo.id}`}
        className={`group relative block w-full overflow-hidden bg-[#0A0A0A] border border-white/5 ${natural ? "" : "h-full"}`}
      >
        <img
          src={fileUrl(photo.image_url)}
          alt={photo.title}
          loading="lazy"
          className={
            natural
              ? "block w-full h-auto transition-transform duration-700 ease-out group-hover:scale-105"
              : "absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500" />
        <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between gap-4">
          <div>
            <span className="block text-[10px] tracking-[0.25em] uppercase text-[#D4AF37] mb-2">{photo.category}</span>
            <h3 className="font-display text-xl md:text-2xl text-white leading-tight">{photo.title}</h3>
          </div>
          <span className="text-sm text-zinc-300 font-medium whitespace-nowrap opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
            ${photo.price.toFixed(0)}
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
